<!-- Desktop HTML -->
<div *ngIf='screenWidth >= 1230'>
  <!-- <div class="visible-lg" (window:orientationchange)="screenRotate($event)"> -->

  <div (window:orientationchange)="screenRotate($event)">
    <div class="flex-container">
      <div class="flex-16">
        <div class="bmw-lg-tool-report-sidebar">
          <div class="bmw-lg-sidebar">
            <app-tool-report-sidebar></app-tool-report-sidebar>
          </div>
        </div>
      </div>
      <div class="flex">
        <div class="flex-container row">
          <div class="flex-5"></div>
          <div class="flex-90">
            <div class="flex-container row">
              <div class="flex-30"></div>
              <div class="flex-container row space-around-center flex-40">
                <div [ngClass]='{"bmw-active-link": isShowAll && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"),
                "mini-active-link": isShowAll && APP_SETTINGS.isMINI === "true",
               "rr-active-link": isShowAll && APP_SETTINGS.isRollsRoyce === "true"}'
                  class="pointer" style="padding-bottom: 20px" (click)='showAll()'>ALL</div>
                <div [ngClass]='{"bmw-active-link": isShowNew && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"),
                "mini-active-link": isShowNew && APP_SETTINGS.isMINI === "true",
                "rr-active-link": isShowNew && APP_SETTINGS.isRollsRoyce === "true"}'
                  class="pointer" style="padding-bottom: 20px" (click)='showNew()'>
                  NEW
                  <div class="badge" *ngIf="newDocsCount>0" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>{{newDocsCount}}</div>
                </div>
                <div [ngClass]='{"bmw-active-link": isShowHistory && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true")
                , "mini-active-link": isShowHistory && APP_SETTINGS.isMINI === "true",
                "rr-active-link": isShowHistory && APP_SETTINGS.isRollsRoyce === "true"}'
                  class="pointer" style="padding-bottom: 20px" (click)='showHistory()'>HISTORY</div>
              </div>
              <div class="flex-30"></div>
            </div>
            <div class="bmw-lg-tool-report">
              <div>
                <div class="bmw-tool-report-header flex-container column" style="padding: 32px 30px 25px 30px">
                  <div style="display: flex;">
                    <div class="bmw-lg-tool-report-title flex">
                      {{ toolReportObject }}<br />
                    </div>
                    <div class="flex-30">
                      <form class="input-group" name="findDocs">
                        <input type="text" size=15 style="height:34px;font-size:16px;font-weight:normal;width: 100%" placeholder="Find Tool" name="techDoc"
                          [(ngModel)]="search4tools">
                        <div class="input-group-btn">
                          <button [ngClass]="{'mini-button-style' : APP_SETTINGS.isMINI === 'true', 'bmw-button-style': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true'),
                          'rr-button-style' : APP_SETTINGS.isRollsRoyce === 'true'}" class="btn btn-default"
                            type="submit" (click)='disablePagination()'>
                            <i class="glyphicon glyphicon-search"></i>
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div style="width: 500px">
                    <p>
                      <a (click)='downloadExcel()'><span style="text-decoration: underline;">Download Tool Report as an Excel file</span> <i class="material-icons" style="float: left; padding-right:10px;">cloud_download</i></a>
                    </p>
                    
                    <div class="clear">
                      Search tools by entering a few digits or the entire
                      <strong>6-digit part number, 11-digit order part number, description, or group number.
                      </strong>
                    </div>
                    <div style="margin-top: 25px">
                      The group number can be used to limit your search to a specific group. The group position in the part number
                      <strong>81 12 9
                        <span [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>42</span>5 008
                      </strong> is
                      <span [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>42</span>.
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex-container row" style="border-bottom:1px solid #e9e9e9;padding:0 15px">
                <div style="display:inherit" class="flex-17">
                  <div style="font-weight:bold;font-size:12px;">Order P/N</div>
                  <i class="fa pointer" (click)="sortByProperty('orderPartNumber')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'orderPartNumber', 'fa-sort-asc bmw-sort-control-asc': (column == 'orderPartNumber' && isDesc), 'fa-sort-desc': (column == 'orderPartNumber' && !isDesc) }"
                    aria-hidden="true"> </i>
                </div>
                <div class="flex-2"></div>
                <div style="display:inherit" class="flex-10">
                  <div style="font-weight:bold;font-size:12px;">6 digit P/N</div>
                  <i class="fa pointer" (click)="sortByProperty('partNumber')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'partNumber', 'fa-sort-asc bmw-sort-control-asc': (column == 'partNumber' && isDesc), 'fa-sort-desc': (column == 'partNumber' && !isDesc) }"
                    aria-hidden="true"> </i>
                </div>
                <div class="flex-2"></div>
                <div style="display:inherit" class="flex-25">
                  <div style="font-weight:bold;font-size:12px;">Description</div>
                </div>
                <div class="flex-2"></div>
                <div style="display:inherit" class="flex-12">
                  <div style="font-weight:bold;font-size:12px;">Brand</div>
                  <i class="fa pointer" (click)="sortByProperty('brand')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'brand', 'fa-sort-asc bmw-sort-control-asc': (column == 'brand' && isDesc), 'fa-sort-desc': (column == 'brand' && !isDesc) }"
                    aria-hidden="true"> </i>
                </div>
                <div class="flex-2"></div>
                <div style="display:inherit" class="flex-15">
                  <div style="font-weight:bold;font-size:12px;">Series</div>
                </div>
                <div class="flex-2"></div>
                <div style="display:inherit" class="flex">
                  <div style="font-weight:bold;font-size:12px;">SIB</div>
                  <i class="fa pointer" (click)="sortByProperty('bulletinDisplayNumber')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'bulletinDisplayNumber', 'fa-sort-asc bmw-sort-control-asc': (column == 'bulletinDisplayNumber' && isDesc), 'fa-sort-desc': (column == 'bulletinDisplayNumber' && !isDesc) }"
                    aria-hidden="true"> </i>
                </div>
                <div class="flex-7"></div>
              </div>
              <div class="alert alert-warning" *ngIf='errorMessage?.length > 0'>{{errorMessage}}</div>
              <div *ngIf='toolReports?.length > 0 && !isPaginateFlag; else disablePaginationSec'>
                <div *ngFor='let report of toolReports | filterResults : filter |
                  searchFilter: "orderPartNumber,partNumber,bulletinDisplayNumber,description,seriesAsString": search4tools |
                  sortBy: {property: column, direction: direction} | paginate: { itemsPerPage: 10, currentPage: page };let i=index'
                  class="flex-container column" style="border-bottom:1px solid #e9e9e9;">
                  <div class="bmw-lg-tool-report-report" style="flex-grow: 1;">

                    <a style="display: flex;" [routerLink]='["/report-detail", report?.id]' [queryParams]="{page:page}" (click)='saveToHistory(isShowHistory, report.id, report?.orderPartNumber)'>
                      <div style="display:inherit" class="flex-17">
                        <div class="flex-container column">
                          <div>
                            {{report?.orderPartNumber}}
                          </div>
                          <div style="font-size:12px;font-weight:bold;color:#b2aa8e" *ngIf='report?.externalMfrgToolWarranty'>
                            External MFR Tool Warranty
                          </div>
                        </div>
                      </div>
                      <div class="flex-2"></div>
                      <div style="display:inherit" class="flex-10">{{report?.partNumber}}</div>
                      <div class="flex-2"></div>
                      <div style="display:inherit" class="flex-25">{{report?.description}}</div>
                      <div class="flex-2"></div>
                      <div style="display:inherit" class="flex-12">{{report?.make.makeName}}</div>
                      <div class="flex-2"></div>
                      <div style="display:inherit" class="flex-15">
                        <div *ngFor='let model of report?.series| loadMoreItems : numOfItems' style="float: left; margin-right:7px">
                          {{model?.seriesName}}
                        </div>
                        <div class="pointer" *ngIf='((report?.series| loadMoreItems : numOfItems)?.length < report?.series?.length)' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'
                          style='float:left'>+6</div>
                      </div>
                      <div class="flex-2"></div>
                      <div style="display:inherit" class="flex">
                        <div class="flex-container column">
                          <div>
                            {{report?.bulletinDisplayNumber}}
                          </div>
                          <div style="font-size:12px;font-weight:bold;color:#2f9612" *ngIf='report?.autoShip'>
                            Autoships
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="flex-7" [ngClass]="{'mini-tool-report-see-more' : APP_SETTINGS.isMINI === 'true', 'bmw-tool-report-see-more': (APP_SETTINGS.isBMW === 'true'|| APP_SETTINGS.isMOTORRAD === 'true'),
                'rr-tool-report-see-more' : APP_SETTINGS.isRollsRoyce === 'true'}">
                    <a (click)='expandReportNotes[i] = !expandReportNotes[i]' [href]='"#notes" + i' data-toggle="collapse">
                      {{expandReportNotes[i] ? "Hide" : "See"}} Notes
                      <i class="material-icons bmw-notes-expand" [ngClass]='{"active": expandReportNotes[i]}'>arrow_downward</i>
                    </a>
                  </div>
                  <div [id]='"notes" + i' class="collapse" style="padding:0 30%">
                    {{report?.notes}}
                  </div>
                </div>
              </div>
              <ng-template #disablePaginationSec>
              <div *ngFor='let report of toolReports | filterResults : filter |
                searchFilter: "orderPartNumber,partNumber,bulletinDisplayNumber,description,seriesAsString": search4tools |
                sortBy: {property: column, direction: direction};let i=index'
                class="flex-container column" style="border-bottom:1px solid #e9e9e9;">
                <div class="bmw-lg-tool-report-report" style="flex-grow: 1;">

                  <a style="display: flex;" [routerLink]='["/report-detail", report?.id]' [queryParams]="{page:page}" (click)='saveToHistory(isShowHistory, report.id, report?.orderPartNumber)'>
                    <div style="display:inherit" class="flex-17">
                      <div class="flex-container column">
                        <div>
                          {{report?.orderPartNumber}}
                        </div>
                        <div style="font-size:12px;font-weight:bold;color:#b2aa8e" *ngIf='report?.externalMfrgToolWarranty'>
                          External MFR Tool Warranty
                        </div>
                      </div>
                    </div>
                    <div class="flex-2"></div>
                    <div style="display:inherit" class="flex-10">{{report?.partNumber}}</div>
                    <div class="flex-2"></div>
                    <div style="display:inherit" class="flex-25">{{report?.description}}</div>
                    <div class="flex-2"></div>
                    <div style="display:inherit" class="flex-12">{{report?.make.makeName}}</div>
                    <div class="flex-2"></div>
                    <div style="display:inherit" class="flex-15">
                      <div *ngFor='let model of report?.series| loadMoreItems : numOfItems' style="float: left; margin-right:7px">
                        {{model?.seriesName}}
                      </div>
                      <div class="pointer" *ngIf='((report?.series| loadMoreItems : numOfItems)?.length < report?.series?.length)' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'
                        style='float:left'>+6</div>
                    </div>
                    <div class="flex-2"></div>
                    <div style="display:inherit" class="flex">
                      <div class="flex-container column">
                        <div>
                          {{report?.bulletinDisplayNumber}}
                        </div>
                        <div style="font-size:12px;font-weight:bold;color:#2f9612" *ngIf='report?.autoShip'>
                          Autoships
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
                <div class="flex-7" [ngClass]="{'mini-tool-report-see-more' : APP_SETTINGS.isMINI === 'true', 'bmw-tool-report-see-more': (APP_SETTINGS.isBMW === 'true'|| APP_SETTINGS.isMOTORRAD === 'true'),
                'rr-tool-report-see-more' : APP_SETTINGS.isRollsRoyce === 'true'}">
                  <a (click)='expandReportNotes[i] = !expandReportNotes[i]' [href]='"#notes" + i' data-toggle="collapse">
                    {{expandReportNotes[i] ? "Hide" : "See"}} Notes
                    <i class="material-icons bmw-notes-expand" [ngClass]='{"active": expandReportNotes[i]}'>arrow_downward</i>
                  </a>
                </div>
                <div [id]='"notes" + i' class="collapse" style="padding:0 30%">
                  {{report?.notes}}
                </div>
              </div>
              </ng-template>
              
            </div>
            <pagination-controls (pageChange)="page = $event;pageNumChange( $event)" [hidden]="isPaginateFlag"></pagination-controls>
          </div>
          <div class="flex"></div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Ipad HTML] -->
<!--<div *ngIf='screenWidth > 991 && screenWidth < 1230'>-->
  <div *ngIf='screenWidth >= 991 && screenWidth <= 1230'>
  <!-- <div class="visible-md" (window:orientationchange)="screenRotate($event)"> -->

  <div (window:orientationchange)="screenRotate($event)">
    <div class="flex-container">
      <div class="flex-16">
        <div class="bmw-lg-tool-report-sidebar">
          <div class="bmw-lg-sidebar">
            <app-tool-report-sidebar></app-tool-report-sidebar>
          </div>
        </div>
      </div>
      <div class="flex">
        <div class="flex-container">
          <div class="flex-5"></div>
          <div class="flex-90">
            <div class="flex-container">
              <div class="flex-30"></div>
              <div class="flex-container space-around-center flex-40">
                <div [ngClass]='{"bmw-active-link": isShowAll && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"),
                "mini-active-link": isShowAll && APP_SETTINGS.isMINI === "true",
               "rr-active-link": isShowAll && APP_SETTINGS.isRollsRoyce === "true"}'
                  class="pointer" style="padding-bottom: 20px" (click)='showAll()'>ALL</div>
                <div [ngClass]='{"bmw-active-link": isShowNew && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"),
                "mini-active-link": isShowNew && APP_SETTINGS.isMINI === "true",
                "rr-active-link": isShowNew && APP_SETTINGS.isRollsRoyce === "true"}'
                  class="pointer" style="padding-bottom: 20px" (click)='showNew()'>
                  NEW
                  <div class="badge" *ngIf="newDocsCount>0" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>{{newDocsCount}}</div>
                </div>
                <div [ngClass]='{"bmw-active-link": isShowHistory && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true")
                , "mini-active-link": isShowHistory && APP_SETTINGS.isMINI === "true",
                "rr-active-link": isShowHistory && APP_SETTINGS.isRollsRoyce === "true"}'
                  class="pointer" style="padding-bottom: 20px" (click)='showHistory()'>HISTORY</div>
              </div>
              <div class="flex-30"></div>
            </div>
            <div class="bmw-lg-tool-report">
              <div>
                <div class="bmw-tool-report-header flex-container row" style="padding: 32px 30px 25px 30px">
                  <div style="display: flex;">
                    <div class="bmw-lg-tool-report-title flex" style="font-size:32px">
                      {{toolReportObject}}
                    </div>
                    <div class="flex-30">
                      <form class="input-group" name="findDocs">
                        <input type="text" size=15 style="height:34px;font-size:16px;font-weight:normal;width: 100%" placeholder="Find Tool" name="techDoc"
                          [(ngModel)]="search4tools">
                        <div class="input-group-btn">
                          <button [ngClass]="{'mini-button-style' : APP_SETTINGS.isMINI === 'true', 'bmw-button-style': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true'),
                          'rr-button-style' : APP_SETTINGS.isRollsRoyce === 'true'}" class="btn btn-default"
                            type="submit">
                            <i class="glyphicon glyphicon-search"></i>
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div style="width: 500px">
                    <div>
                      Search tools by entering a few digits or the entire
                      <strong>6-digit part number, 11-digit order part number, description, or group number.
                      </strong>
                    </div>
                    <div style="margin-top: 25px">
                      The group number can be used to limit your search to a specific group. The group position in the part number
                      <strong>81 12 9
                        <span [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>42</span>5 008
                      </strong> is
                      <span [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>42</span>.
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex-container row" style="border-bottom:1px solid #e9e9e9;padding:0 15px">
                <div style="display:inherit" class="flex-17">
                  <div style="font-weight:bold;font-size:12px;">Order P/N</div>
                  <i class="fa pointer" (click)="sortByProperty('orderPartNumber')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'orderPartNumber', 'fa-sort-asc bmw-sort-control-asc': (column == 'orderPartNumber' && isDesc), 'fa-sort-desc': (column == 'orderPartNumber' && !isDesc) }"
                    aria-hidden="true"> </i>
                </div>
                <div class="flex-2"></div>
                <div style="display:inherit" class="flex-10">
                  <div style="font-weight:bold;font-size:12px;">6 digit P/N</div>
                  <i class="fa pointer" (click)="sortByProperty('partNumber')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'partNumber', 'fa-sort-asc bmw-sort-control-asc': (column == 'partNumber' && isDesc), 'fa-sort-desc': (column == 'partNumber' && !isDesc) }"
                    aria-hidden="true"> </i>
                </div>
                <div class="flex-2"></div>
                <div style="display:inherit" class="flex-25">
                  <div style="font-weight:bold;font-size:12px;">Description</div>
                </div>
                <div class="flex-2"></div>
                <div style="display:inherit" class="flex-12">
                  <div style="font-weight:bold;font-size:12px;">Brand</div>
                </div>
                <div class="flex-2"></div>
                <div style="display:inherit" class="flex-15">
                  <div style="font-weight:bold;font-size:12px;">Series</div>
                </div>
                <div class="flex-2"></div>
                <div style="display:inherit" class="flex">
                  <div style="font-weight:bold;font-size:12px;">SIB</div>
                  <i class="fa pointer" (click)="sortByProperty('bulletinDisplayNumber')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'bulletinDisplayNumber', 'fa-sort-asc bmw-sort-control-asc': (column == 'bulletinDisplayNumber' && isDesc), 'fa-sort-desc': (column == 'bulletinDisplayNumber' && !isDesc) }"
                    aria-hidden="true"> </i>
                </div>
                <div class="flex-7"></div>
              </div>
              <div *ngFor='let report of toolReports | filterResults : filter |
                                searchFilter: "orderPartNumber,partNumber,bulletinDisplayNumber,description,seriesAsString": search4tools |
                                sortBy: {property: column, direction: direction};let i=index' class="flex-container column" style="border-bottom:1px solid #e9e9e9;">
                <div class="bmw-lg-tool-report-report" style="flex-grow: 1; font-size:12px">
                  <a style="display: flex;"  [routerLink]='["/report-detail", report?.id]' [queryParams]="{page:page}" (click)='saveToHistory(isShowHistory, report.id, report?.orderPartNumber)'>
                  <!--<a href={{report?.documentFileName}} target="_blank" (click)='saveToHistory(isShowHistory, report.id, report?.orderPartNumber)'>-->
                    <div style="display:inherit" class="flex-17">
                      <div class="flex-container column">
                        <div>
                          {{report?.orderPartNumber}}
                        </div>
                        <div style="font-size:12px;font-weight:bold;color:#b2aa8e" *ngIf='report?.externalMfrgToolWarranty'>
                          External MFR Tool Warranty
                        </div>
                      </div>
                    </div>
                    <div class="flex-2"></div>
                    <div style="display:inherit" class="flex-10">{{report?.partNumber}}</div>
                    <div class="flex-2"></div>
                    <div style="display:inherit" class="flex-25">{{report?.description}}</div>
                    <div class="flex-2"></div>
                    <div style="display:inherit" class="flex-12">{{report?.make.makeName}}</div>
                    <div class="flex-2"></div>
                    <div style="display:inherit" class="flex-15">
                      <div *ngFor='let series of report?.series| loadMoreItems : numOfItems' style="float: left; margin-right:7px">
                        {{series?.seriesName}}
                      </div>
                      <div class="pointer" *ngIf='((report?.series| loadMoreItems : numOfItems)?.length < report?.series?.length)' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'
                        style='float:left'>+6</div>
                    </div>
                    <div class="flex-2"></div>
                    <div style="display:inherit" class="flex">
                      <div class="flex-container column">
                        <div>
                          {{report?.bulletinDisplayNumber}}
                        </div>
                        <div style="font-size:12px;font-weight:bold;color:#2f9612" *ngIf='report?.autoShip'>
                          Autoships
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
                <div class="flex-7" [ngClass]="{'mini-tool-report-see-more' : APP_SETTINGS.isMINI === 'true', 'bmw-tool-report-see-more': (APP_SETTINGS.isBMW === 'true'|| APP_SETTINGS.isMOTORRAD === 'true'),
                'rr-tool-report-see-more' : APP_SETTINGS.isRollsRoyce === 'true'}">
                  <a (click)='expandReportNotes[i] = !expandReportNotes[i]' [href]='"#notes" + i' data-toggle="collapse">
                    {{expandReportNotes[i] ? "Hide" : "See"}} Notes
                    <i class="material-icons bmw-notes-expand" [ngClass]='{"active": expandReportNotes[i]}'>arrow_downward</i>
                  </a>
                </div>
                <div [id]='"notes" + i' class="collapse" style="padding:0 30%">
                  {{report?.notes}}
                </div>
              </div>
            </div>
          </div>
          <div class="flex"></div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Tablet HTML -->
<div *ngIf='screenWidth > 767 && screenWidth < 991'>
  <!-- <div class="visible-sm" (window:orientationchange)="screenRotate($event)"> -->

  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-sm-tool-report" [ngStyle]='{"display": activeLink ? "none" : "block"}'>
      <app-tool-report-sidebar></app-tool-report-sidebar>
    </div>
    <div *ngIf='activeLink'>
      <div class="flex-container">
        <div class="flex-25"></div>
        <div class="flex-container row space-around-center">
          <div [ngClass]='{"bmw-active-link": isShowAll && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"),
          "mini-active-link": isShowAll && APP_SETTINGS.isMINI === "true",
         "rr-active-link": isShowAll && APP_SETTINGS.isRollsRoyce === "true"}'
            class="pointer" style="padding-bottom: 20px" (click)='showAll()'>ALL</div>
          <div [ngClass]='{"bmw-active-link": isShowNew && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"),
          "mini-active-link": isShowNew && APP_SETTINGS.isMINI === "true",
          "rr-active-link": isShowNew && APP_SETTINGS.isRollsRoyce === "true"}'
            class="pointer" style="padding-bottom: 20px" (click)='showNew()'>
            NEW
            <div class="badge" *ngIf="newDocsCount>0" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>{{newDocsCount}}</div>
          </div>
          <div [ngClass]='{"bmw-active-link": isShowHistory && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true")
          , "mini-active-link": isShowHistory && APP_SETTINGS.isMINI === "true",
          "rr-active-link": isShowHistory && APP_SETTINGS.isRollsRoyce === "true"}'
            class="pointer" style="padding-bottom: 20px" (click)='showHistory()'>HISTORY</div>
        </div>
        <div class="flex-25"></div>
      </div>
      <div class="bmw-sm-tool-report-content">
        <div style="float: right;margin: 10px 10px 0 0" class="flex-container row">
          <div data-toggle="modal" data-target="#filterModal" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-sm-tool-report-filter">
            <i class="material-icons filter-icon" style="float: left">filter_list</i>
            <div style="float: left; padding-left: 5px; line-height: 1.6">Filter</div>
          </div>
        </div>
        <div class="bmw-lg-tool-report-title flex-container row" style="text-align: center; padding-top: 20px">
          {{toolReportObject}}
        </div>
        <div class="flex-container row" style="padding: 10px 10px 15px 10px">
          <div class="flex-55">
            <div>
              Search tools by entering a few digits or the entire
              <strong>6-digit part number, 11-digit order part number, description, or group number.
              </strong>
            </div>
            <div style="margin-top: 20px">
              The group number can be used to limit your search to a specific group. The group position in the part number
              <strong>81 12 9
                <span [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>42</span>5 008
              </strong> is
              <span [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>42</span>.
            </div>
          </div>
          <div class="flex-2"></div>
          <div class="flex-40">
            <form class="input-group" name="findDocs">
              <input type="text" size=15 style="height:34px;font-size:16px;font-weight:normal;width: 100%" placeholder="Find Tool" name="techDoc"
                [(ngModel)]="search4tools">
              <div class="input-group-btn">
                <button [ngClass]="{'mini-button-style' : APP_SETTINGS.isMINI === 'true', 'bmw-button-style': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true'),
                'rr-button-style' : APP_SETTINGS.isRollsRoyce === 'true'}" class="btn btn-default"
                  type="submit">
                  <i class="glyphicon glyphicon-search"></i>
                </button>
              </div>
            </form>
          </div>
        </div>
        <div class="flex-container row" style="border-bottom:1px solid #e9e9e9;padding:0 15px">
          <div style="display:inherit" class="flex-20">
            <div style="font-weight:bold;font-size:12px;">Order P/N</div>
            <i class="fa pointer" (click)="sortByProperty('orderPartNumber')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'orderPartNumber', 'fa-sort-asc bmw-sort-control-asc': (column == 'orderPartNumber' && isDesc), 'fa-sort-desc': (column == 'orderPartNumber' && !isDesc) }"
              aria-hidden="true"> </i>
          </div>
          <div class="flex-2"></div>
          <div style="display:inherit" class="flex-15">
            <div style="font-weight:bold;font-size:12px;">6 digit P/N</div>
            <i class="fa pointer" (click)="sortByProperty('partNumber')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'partNumber', 'fa-sort-asc bmw-sort-control-asc': (column == 'partNumber' && isDesc), 'fa-sort-desc': (column == 'partNumber' && !isDesc) }"
              aria-hidden="true"> </i>
          </div>
          <div class="flex-2"></div>
          <div style="display:inherit" class="flex-30">
            <div style="font-weight:bold;font-size:12px;">Description</div>
          </div>
          <div class="flex-2"></div>
          <div style="display:inherit" class="flex-15">
            <div style="font-weight:bold;font-size:12px;">Brand</div>
          </div>
          <div class="flex-2"></div>
          <div style="display:inherit" class="flex">
            <div style="font-weight:bold;font-size:12px;">SIB</div>
            <i class="fa pointer" (click)="sortByProperty('bulletinDisplayNumber')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'bulletinDisplayNumber', 'fa-sort-asc bmw-sort-control-asc': (column == 'bulletinDisplayNumber' && isDesc), 'fa-sort-desc': (column == 'bulletinDisplayNumber' && !isDesc) }"
              aria-hidden="true"> </i>
          </div>
          <div class="flex-7"></div>
        </div>
        <div *ngFor='let report of toolReports | filterResults : filter |
                              searchFilter: "orderPartNumber,partNumber,bulletinDisplayNumber,description,seriesAsString": search4tools |
                              sortBy: {property: column, direction: direction};let i=index' style="border-bottom:1px solid #e9e9e9;">
          <div class="bmw-lg-tool-report-report flex-container column" style="flex-grow: 1;">
            <a style="display: flex;" [routerLink]='["/report-detail", report?.id]' [queryParams]="{page:page}" (click)='saveToHistory(isShowHistory, report.id, report?.orderPartNumber)'>
              <div style="display:inherit" class="flex-20">
                <div class="flex-container column">
                  <div>
                    {{report?.orderPartNumber}}
                  </div>
                  <div style="font-size:12px;font-weight:bold;color:#b2aa8e" *ngIf='report?.externalMfrgToolWarranty'>
                    External MFR Tool Warranty
                  </div>
                </div>
              </div>
              <div class="flex-2"></div>
              <div style="display:inherit" class="flex-15">{{report?.partNumber}}</div>
              <div class="flex-2"></div>
              <div style="display:inherit" class="flex-30">{{report?.description}}</div>
              <div class="flex-2"></div>
              <div style="display:inherit" class="flex-15">{{report?.make.makeName}}</div>
              <div class="flex-2"></div>
              <div style="display:inherit" class="flex">
                <div class="flex-container column">
                  <div>
                    {{report?.bulletinDisplayNumber}}
                  </div>
                  <div style="font-size:12px;font-weight:bold;color:#2f9612" *ngIf='report?.autoShip'>
                    Autoships
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div class="flex-7" [ngClass]="{'mini-tool-report-see-more' : APP_SETTINGS.isMINI === 'true', 'bmw-tool-report-see-more': (APP_SETTINGS.isBMW === 'true'|| APP_SETTINGS.isMOTORRAD === 'true'),
          'rr-tool-report-see-more' : APP_SETTINGS.isRollsRoyce === 'true'}">
            <a (click)='expandReportModels[i] = !expandReportModels[i]' [href]='"#series" + i' data-toggle="collapse">
              {{expandReportModels[i] ? "Hide" : "See"}} series
              <i class="material-icons bmw-notes-expand" [ngClass]='{"active": expandReportModels[i]}'>arrow_downward</i>
            </a>
            <a (click)='expandReportNotes[i] = !expandReportNotes[i]' [href]='"#notes" + i' data-toggle="collapse" style="padding-left:48%">
              {{expandReportNotes[i] ? "Hide" : "See"}} Notes
              <i class="material-icons bmw-notes-expand" [ngClass]='{"active": expandReportNotes[i]}'>arrow_downward</i>
            </a>
          </div>
          <div class="flex-container row">
            <div class="flex-50">
              <div [id]='"series" + i' class="collapse" style="padding-left: 100px;display: inline-flex" *ngIf='expandReportModels[i]'>
                <div *ngFor='let series of report?.series' style="margin-right:7px">
                  {{series?.seriesName}}
                </div>
              </div>
            </div>
            <div class="flex-50">
              <div [id]='"notes" + i' class="collapse" *ngIf='expandReportNotes[i]' class="bmw-sm-tool-report-collapse-notes">
                {{report?.notes}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade bmw-sm-modal-dialog" id="filterModal" role="dialog">
      <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color:white">&times;</button>
            <h4 class="modal-title">Filter</h4>
          </div>
          <div class="modal-body">
            <div class="row bmw-no-gutter">
              <div class="row bmw-no-gutter">Service Bulletin</div>
              <div class="row bmw-no-gutter">
                <input [(ngModel)]='inputSIB' style="width:100%" type="input" placeholder="Enter associated SIB">
              </div>
            </div>
            <div class="flex-container row">
              <div class="flex-55">Brand</div>
              <div class="flex-15"></div>
              <div class="flex">Series</div>
            </div>
            <div style="margin:20px 0 20px 20px">
              <label class="bmw-onoffswitch-checkbox">Autoships
                <input [(ngModel)]="checkAutoships" type="checkbox" name="onoffswitch">
                <span class="checkmark"></span>
              </label>
              <label class="bmw-onoffswitch-checkbox">External MFR Tool Warranty
                <input [(ngModel)]="checkExternalMFR" type="checkbox" name="onoffswitch">
                <span class="checkmark"></span>
              </label>
            </div>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
            <div class="row bmw-no-gutter">
              <div class="col-xs-6">
                <div class="bmw-button-secondary" style="border:2px solid #fff;padding:7px" (click)='clearFilter()'>Clear Filter</div>
              </div>
              <div class="col-xs-6">
                <div data-dismiss="modal" style="padding:7px;border:2px solid" [ngStyle]='{"border-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'
                  [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-button-primary" (click)='applyFilter()'>Apply Filter</div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
<!-- Mobile HTML -->
<div *ngIf='screenWidth > 319 && screenWidth < 767'>
  <!-- <div class="visible-xs" (window:orientationchange)="screenRotate($event)"> -->

  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-xs-tool-report" [ngStyle]='{"display": activeLink ? "none" : "block"}'>
      <app-tool-report-sidebar></app-tool-report-sidebar>
    </div>
    <div *ngIf='activeLink'>
      <div class="flex-container" style="margin: 0px 15px">
        <div class="flex-container row flex-align-center">
          <div [ngClass]='{"bmw-active-link": isShowAll && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"),
          "mini-active-link": isShowAll && APP_SETTINGS.isMINI === "true",
         "rr-active-link": isShowAll && APP_SETTINGS.isRollsRoyce === "true"}'
            class="pointer" style="padding-bottom: 20px" (click)='showAll()'>ALL</div>
          <div [ngClass]='{"bmw-active-link": isShowNew && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"),
          "mini-active-link": isShowNew && APP_SETTINGS.isMINI === "true",
          "rr-active-link": isShowNew && APP_SETTINGS.isRollsRoyce === "true"}'
            class="pointer" style="padding-bottom: 20px" (click)='showNew()'>
            NEW
            <div class="badge" *ngIf="newDocsCount>0" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>{{newDocsCount}}</div>
          </div>
          <div [ngClass]='{"bmw-active-link": isShowHistory && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true")
          , "mini-active-link": isShowHistory && APP_SETTINGS.isMINI === "true",
          "rr-active-link": isShowHistory && APP_SETTINGS.isRollsRoyce === "true"}'
            class="pointer" style="padding-bottom: 20px" (click)='showHistory()'>HISTORY</div>
        </div>
      </div>
      <div class="bmw-xs-tool-report-content">
        <div style="float: right;margin: 10px 10px 0 0" class="flex-container row">
          <div data-toggle="modal" data-target="#filterModal1" class="bmw-xs-tool-report-filter" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>
            <i class="material-icons filter-icon" style="float: left" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>filter_list</i>
            <div style="float: left; padding-left: 5px; line-height: 1.6">Filter</div>
          </div>
        </div>
        <div class="bmw-xs-tool-report-title flex-container row">
          {{toolReportObject}}
        </div>
        <div style="width:90%;margin:8px 15px">
          <form class="input-group" name="findDocs" style="width: 100%">
            <input type="text" class="form-control" size=15 style="height:34px;font-size:16px;border-radius:0px" placeholder="Find Tools"
              name="techDoc" [(ngModel)]="search4tools">
            <div class="input-group-btn">
              <button [ngClass]="{'mini-button-style' : APP_SETTINGS.isMINI === 'true', 'bmw-button-style': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true'),
              'rr-button-style' : APP_SETTINGS.isRollsRoyce === 'true'}" class="btn btn-default"
                type="submit">
                <i class="glyphicon glyphicon-search"></i>
              </button>
            </div>
          </form>
        </div>
        <div class="flex-container row" style="padding: 0px 10px 10px 10px">
          <div>
            Search tools by entering a few digits or the entire
            <strong>6-digit part number, 11-digit order part number, description, or group number.
            </strong>
          </div>
          <div style="margin-top: 20px">
            The group number can be used to limit your search to a specific group. The group position in the part number
            <strong>81 12 9
              <span [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>42</span>5 008
            </strong> is
            <span [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>42</span>.
          </div>
        </div>
        <div *ngFor='let report of toolReports | filterResults : filter |
                                  searchFilter: "orderPartNumber,partNumber,bulletinDisplayNumber,description,seriesAsString": search4tools |
                                  sortBy: {property: column, direction: direction};let i=index' class="bmw-xs-tool-report-doc">
          <a style="display: flex;" [routerLink]='["/report-detail", report?.id]' [queryParams]="{page:page}" (click)='saveToHistory(isShowHistory, report.id, report?.orderPartNumber)'>
            <div class="flex-container row">
              <div class="flex-40">
                <div>{{report?.orderPartNumber}}</div>
              </div>
              <div class="flex" style="text-align:center">
                <div>{{report?.partNumber}}</div>
              </div>
              <div class="flex-30">
                <div style="text-align: right">{{report?.bulletinDisplayNumber}}</div>
              </div>
            </div>
            <div class="flex-container row">
              <div class="flex-container column flex-50">
                <div>{{report?.description}}</div>
                <div>{{report?.make}}</div>
              </div>
              <div class="flex-container colum">
                <div style="font-size:12px;font-weight:bold;color:#2f9612;text-align:right" *ngIf='report?.autoShip'>
                  Autoships
                </div>
                <div style="font-size:12px;font-weight:bold;color:#b2aa8e;text-align:right" *ngIf='report?.externalMfrgToolWarranty'>
                  External MFR Tool Warranty
                </div>
              </div>
            </div>
          </a>
          <div class="bmw-xs-tool-report-see-more">
            <a (click)='expandReportModels[i] = !expandReportModels[i]' [href]='"#series" + i' data-toggle="collapse">
              {{expandReportModels[i] ? "Hide" : "See"}} Series
              <i class="material-icons bmw-notes-expand" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' [ngClass]='{"active": expandReportModels[i]}'>arrow_downward</i>
            </a>
            <a (click)='expandReportNotes[i] = !expandReportNotes[i]' [href]='"#notes" + i' data-toggle="collapse" style="padding-left:35%">
              {{expandReportNotes[i] ? "Hide" : "See"}} Notes
              <i class="material-icons bmw-notes-expand" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' [ngClass]='{"active": expandReportNotes[i]}'>arrow_downward</i>
            </a>
          </div>
          <div class="flex-container row">
            <div class="flex-30">
              <div [id]='"series" + i' class="collapse" style="display: inline-flex" *ngIf='expandReportModels[i]'>
                <div *ngFor='let series of report?.series' style="margin-right:7px">
                  {{series?.seriesName}}
                </div>
              </div>
            </div>
            <div class="flex-2"></div>
            <div class="flex">
              <div [id]='"notes" + i' class="collapse" *ngIf='expandReportNotes[i]' class="bmw-xs-tool-report-collapse-notes">
                {{report?.notes}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade bmw-sm-modal-dialog" id="filterModal1" role="dialog">
      <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color:white">&times;</button>
            <h4 class="modal-title">Filter</h4>
          </div>
          <div class="modal-body">
            <div class="row bmw-no-gutter">
              <div class="row bmw-no-gutter">Service Bulletin</div>
              <div class="row bmw-no-gutter">
                <input [(ngModel)]='inputSIB' style="width:100%" type="input" placeholder="Enter associated SIB">
              </div>
            </div>
            <div class="flex-container row">
              <div class="flex-55">Brand</div>
              <div class="flex-15"></div>
              <div class="flex">Series</div>
            </div>
            <div class="flex-mrgin:20px 0 20px 20px">
              <label class="bmw-onoffswitch-checkbox">Autoships
                <input [(ngModel)]="checkAutoships" type="checkbox" name="onoffswitch">
                <span class="checkmark"></span>
              </label>
              <label class="bmw-onoffswitch-checkbox">External MFR Tool Warranty
                <input [(ngModel)]="checkExternalMFR" type="checkbox" name="onoffswitch">
                <span class="checkmark"></span>
              </label>
            </div>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
            <div class="row bmw-no-gutter">
              <div class="col-xs-6">
                <div class="bmw-button-secondary" style="border:2px solid #fff;padding:7px" (click)='clearFilter()'>Clear Filter</div>
              </div>
              <div class="col-xs-6">
                <div data-dismiss="modal" style="padding:7px;border:2px solid" [ngStyle]='{"border-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'
                  [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-button-primary" (click)='applyFilter()'>Apply Filter</div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>